<section class="section section--with-rounded-bg section--secondary" [ngClass]="class">
  <div class="section__header">
    <div class="section__title">
      <h5>{{ titleHeading }}</h5>
    </div>
    <div class="section__actions">
      <div class="actions-wrapper">
        <div class="flex-row flex-row--no-spacings flex-row--align-v-center flex-row--align-h-right">
          <ng-content select="[dropdownFilter]"></ng-content>
          <div *ngIf="isCalendarEnabled"
               [ngClass]="{ 'flex-col-xs-3 flex-col-sm-2 flex-col': !isAdvanceCalendar, 'flex-col-xs-4 flex-col-sm-3 flex-col': isAdvanceCalendar }">
            <advance-daterangepicker *ngIf="isAdvanceCalendar" (click)="onClickOutSide($event)"
                                     (apply)="handleApply($event)">
            </advance-daterangepicker>

            <advance-daterangepicker *ngIf="!isAdvanceCalendar" (click)="onClickOutSide($event)"
                                     (apply)="handleApply($event)" [isSinglePicker]="true">
            </advance-daterangepicker>
          </div>
          <div class="flex-col-xs-3 flex-col-sm-4">
            <app-predective-search [callbackFunction]="handleLocalFilter" [callbackClearFunction]="handleClearLocalFilter"  [isNewPreview]="true"></app-predective-search>
          </div>
          <!-- <div [class]="'flex-col-sm-' + getActionIconsCols()"> -->
          <!-- <div [class]="'flex-col-xs-2 flex-col-sm-' + getActionIconsCols()"> -->
          <div class="flex-col">
            <div class="icons-group-container data-grid-icons-container" (clickOutside)="onClickOutSide($event)">
              <div class="icons-group icons-group--tertiary">
                <div class="icons-group__icons">
                  <div class="search-filter search-filter--revised" *ngIf="colNames && colNames.length > 0">
                    <a (click)="toggleColFilter()" data-toggle="search-filter" class="search-filter__btn"
                       data-tooltip="Columns Filter" data-tooltip-conf="top">
                      <i class="fa-light fa-bars-filter"></i>
                    </a>
                    <div class="search-filter__results" data-results="search-filter"
                         [style.height]="30 * colNames.length + 30 + 'px'"
                         [ngStyle]="{ display: showColFilter ? '' : 'none' }">
                      <ng-scrollbar track="all" visibility="hover">
                        <div class="checkbox" *ngFor="let t of colNames; let i = index">
                          <div class="checkbox__content">
                            <input [(ngModel)]="t.Value" (change)="setTableField($event, t.Name)" type="checkbox"
                                   name="checkbox-{{i+1}}" id="checkbox-{{i+1}}">
                            <label for="checkbox-{{i+1}}">{{t.Name}}</label>
                          </div>
                        </div>
                      </ng-scrollbar>
                    </div>
                  </div>
                  <span data-tooltip="Refresh Grid" data-tooltip-conf="top" *ngIf="isRefreshEnabled">
                    <i class="fa-light fa-arrows-rotate"></i>
                  </span>
                  <span data-tooltip="Export to excel" data-tooltip-conf="top" (click)="handleExport()"
                        *ngIf="isExportEnabled">
                    <i class="fa-light fa-file-export"></i>
                  </span>
                  <span data-tooltip="Toggle Filters" data-tooltip-conf="top" (click)="toggleFilters()"
                        *ngIf="isFiltersEnabled">
                    <i class="fa-light fa-filters" data-toggle="filter-form-toggle"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="section__form">
    <div class="filter-toggle-form collapsed" [ngClass]="{ 'collapsed': !showFilters }">
      <div class="filters-result">

        <form action="" class="form-fields-group form-fields form-fields--grouped ">
          <ng-container *ngFor="let sFields of searchFields; let i = index">
            <div *ngIf="sFields.Type === 'string'" class="single-input-field-wrapper">
              <input type="text" name="key_{{sFields.DisplayName}}" placeholder={{sFields.DisplayName}}
                     [(ngModel)]="sFields.Value" class="form-fields__input">
              <!-- <div class="validation validation--error">Full name is not entered.
                                </div> -->
            </div>
            <div *ngIf="sFields.Type === 'dropdown'" class="dropdown-list-wrapper">
              <div class="dropdown-list">
                <f-dropdown [filter]="true" placeholder={{sFields.DisplayName}} name="key_{{sFields.DisplayName}}"
                            [options]="$any(sFields.Options)" optionLabel="label" optionValue="value"
                            [(ngModel)]="sFields.Value" styleClass="search_filter__dropdown ">
                </f-dropdown>
              </div>
            </div>
          </ng-container>

          <!-- <div class="calendar-module calendar-module--tertiary">
            <div class="calendar-module__data">
              <div class="chips chips--call-mon-v2">
                <i class="fa-light fa-calendar chips__icon"></i>
                <span class="chips__value">Date</span>
              </div>
            </div>
          </div> -->
          <a (click)="handleSearchFields()" class="single-btn-with-icon-bg"><i
               class="fa-light fa-magnifying-glass"></i></a>
        </form>
      </div>
    </div>
  </div>
  <div class="section__content">
    <div class="table-scrollable table-scrollable--revised" [ngClass]="{ 'filter-toggle-form__open': showFilters }">
      <ng-scrollbar track="all" visibility="hover" style="height: 100%;">
        <f-table [tableClass]="'table-module table-module-v3'" [columns]="columnsData"
                 [rows]="rowsData | paginate: pagingConfig">
          <ng-template tTemplate="header" let-columns="columns">
            <tr>
              <ng-container *ngFor="let column of columns">
                <ng-container *ngIf="column.display !== false">
                  <th class="nowrap" [columnSort]="column" (sort)="handleColSort($event)">
                    <ng-container *ngIf="column.name.split(' ') as cName">
                      <ng-container *ngIf="cName.length > 1; else colName">
                        <div class="one-line-header">
                          {{ cName[0] }}
                          <ng-container  *ngIf="column.sort !== false">
                            <ng-container [ngTemplateOutlet]="sortOption"></ng-container>
                          </ng-container>
                          <div class="secondary-table-header">{{ cName.slice(1).join(' ') }}</div>
                        </div>
                      </ng-container>
                      <ng-template #colName>
                        <div class="one-line-header">
                          {{ column.name }}
                          <ng-container  *ngIf="column.sort !== false">
                            <ng-container [ngTemplateOutlet]="sortOption"></ng-container>
                          </ng-container>
                        </div>
                      </ng-template>
                      <ng-template #sortOption>
                        <span *ngIf="!column.order">
                          <i class="fa fa-sort"></i>
                        </span>
                        <span *ngIf="column.order > 0">
                          <i class="fa-duotone fa-sort-up"></i>
                        </span>
                        <span *ngIf="column.order < 0">
                          <i class="fa-duotone fa-sort-down"></i>
                        </span>
                      </ng-template>
                    </ng-container>
                  </th>
                </ng-container>
              </ng-container>
            </tr>
          </ng-template>
          <ng-template tTemplate="nodata">
            <tr>
              <td colspan="100%" align="center">
                <i class="no-data__icon fa-light fa-database"></i>
                No {{ titleHeading.toLowerCase() }} record available.
              </td>
            </tr>
            <tr></tr>
          </ng-template>
          <ng-template tTemplate="body" let-row="row" let-rowIndex="rowIndex" *ngIf="!customTBoday">
            <tr>
              <ng-container *ngFor="let column of columnsData">

                <td *ngIf="column.display !== false">
                  <ng-container
                                *ngIf="column.key !== 'CreatedOn' && column.key !== 'channel_type' && column.key !== 'rating' && column.key !== 'action' && column.key !== 'chat_no' && column.key !== 'user' && column.key !== 'user_detail' && column.key !== 'message_body' && column.key !== 'email_sent_to' && column.key !==  'email_status' && column.key !==  'disposition' && column.key !==  'callSID' && column.key !==  'campaign_name' && column.key !==  'customer_site_url'">
                    <span [attr.data-tooltip]="column.name + ': \n' + row[column.key]" data-tooltip-conf="top"> {{ row[column.key]}}</span>
                  </ng-container>

                  <ng-container *ngIf="column.key === 'campaign_name'">
                    <span [attr.data-tooltip]="column.name + ': \n' + row[column.key]" data-tooltip-conf="top"> {{ row[column.key] | campaignCode}}</span>
                  </ng-container>

                  <ng-container *ngIf="column.key === 'customer_site_url'">
                    <div class="chat-box chat-box--table site-url">
                      <p class="chat-box__message text-overflow">
                        {{ row[column.key]}}
                      </p>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="column.key === 'disposition' || column.key === 'callSID'">
                    <span [attr.data-tooltip]="column.name + ': \n' + row[column.key]" data-tooltip-conf="top">
                      <span class="call_sid"> {{ row[column.key]}}</span>
                    </span>
                  </ng-container>


                  <ng-container *ngIf="column.key === 'CreatedOn'">
                    <span [attr.data-tooltip]="column.name + ': \n' + moment(row[column.key]).format('DD-MMM-YY')" data-tooltip-conf="top">{{
                      moment(row[column.key]).format('DD-MMM-YY') }}</span>
                  </ng-container>

                  <ng-container *ngIf="column.key === 'user'">
                    <div class="user-module user-module--detailed">
                      <div class="user-module__avatar">
                        <span>
                          <i></i>
                        </span>
                      </div>
                      <div class="user-module__details">
                        <span>{{ row[column.key] }}</span>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="column.key === 'user_detail'">
                    <div class="user-module user-module--detailed">
                      <div class="user-module__avatar">
                        <span>
                          <ng-container *ngIf="row['profile_pic']">
                            <img [src]="row['profile_pic']" />
                          </ng-container>
                          <ng-container *ngIf="!row['profile_pic'] && row[column.key]">
                            {{getNameInitials(row[column.key])}}
                          </ng-container>
                        </span>
                      </div>
                      <div class="user-module__details">
                        <span>{{ row[column.key] ? row[column.key] : 'N/A' }}</span>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="column.key === 'message_body'">
                    <div class="chat-box chat-box--table">
                      <p class="chat-box__message text_overflow">
                        {{ row[column.key]}}
                      </p>
                    </div>
                  </ng-container>

                  <!-- <ng-container *ngIf="column.key === 'email_sent_to'">
                    <div class="pills-grp">
                      <ng-container *ngFor="let x of row[column.key]|splitComma">
                        <div class="pills pills--email">
                          <div class="pills__content">
                            <span class="bg-rounded">{{x}}</span>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </ng-container> -->

                  <ng-container *ngIf="column.key === 'action'" [ngTemplateOutlet]="action"
                                [ngTemplateOutletContext]="{$implicit: {row: row, column: column}}">
                  </ng-container>

                  <ng-container *ngIf="column.key === 'chat_no'">
                    <i [ngClass]="getClosedIcon(row.date_closed)"></i>
                    {{ row[column.key] ? row[column.key] : 'N/A' }}
                  </ng-container>

                  <ng-container *ngIf="column.key === 'email_status'">
                    {{emailStatus[row[column.key]]}}
                  </ng-container>

                  <ng-container *ngIf="column.key === 'channel_type'">
                    <i [ngClass]="getChannnelIconByType(row[column.key])"></i>
                  </ng-container>

                  <ng-container *ngIf="column.key === 'rating'">

                    <ng-container *ngIf="row[column.key]">
                      <span [attr.data-tooltip]="column.name + ': \n' + row[column.key]" data-tooltip-conf="top" role="button" style="position: relative; float: left; text-align: center;"><i
                           class="fa-star far"
                           style="color: var(--accent-table-icon-primary); float: left; font-size: 20px; transform-origin: center center; transform: scale(1); opacity: 0.15; filter: drop-shadow(var(--accent-table-icon-primary) 0px 0px 1px);"></i><span
                              style="background-clip: text; position: absolute; inset: 0px;"><i class="fas fa-star"
                             style="float: left; font-size: 20px;-webkit-text-fill-color:var(--accent-table-icon-primary)"></i></span></span>
                    </ng-container>
                    <ng-container *ngIf="!row[column.key]">
                      <span role="button" style="position: relative; float: left; text-align: center;"><i
                           class="fa-star far"
                           style="color: var(--accent-table-icon-primary); float: left; font-size: 20px; transform-origin: center center; transform: scale(1); opacity: 0.15; filter: drop-shadow(var(--accent-table-icon-primary) 0px 0px 1px);"></i><span
                              style="background-clip: text; position: absolute; inset: 0px;"><i class="fas fa-star"
                             style="float: left; font-size: 20px;-webkit-text-fill-color:transparent"></i></span></span>
                    </ng-container>


                  </ng-container>
                </td>

              </ng-container>
            </tr>
          </ng-template>

          <ng-template tTemplate="bodyDetail" let-data="data" let-row="row" *ngIf="!customTBoday && bodyDetail">
            <ng-container [ngTemplateOutlet]="bodyDetail" [ngTemplateOutletContext]="{$implicit: { data, row }}">
            </ng-container>
          </ng-template>
          <!-- custom template body -->
          <ng-content select="[customTBody]" *ngIf="customTBoday">
          </ng-content>
        </f-table>
      </ng-scrollbar>

    </div>

    <pagination-controls [maxSize]="pagingConfig.itemsPerPage" (pageChange)="handlePageChange($event)"
                         (pageSizeChange)="handlePageSizeChange($event)" [id]="pagingConfig.id"
                         [isNewPreview]="true"></pagination-controls>


  </div>
</section>
